import { ExceptionUtils } from "#src/utils/exception";
import {
  partitionUIConfigurationsByVisibility,
  pickDefaultOrFirstUIConfiguration,
} from "#src/contexts/UserInterfaceConfigurationResolution.helpers";
import { UserInterfaceConfigurationAdapter } from "@validereinc/domain";

type LandingPageConfigurationType = {
  "redirect-to": string;
};

/**
 * Fetches the user's custom landing page redirect configuration
 * @param userId - The user's ID
 * @returns The redirect path if configured, otherwise null
 */
export const fetchUserLandingPageRedirect = async (
  userId: string
): Promise<string | null> => {
  try {
    const response = await UserInterfaceConfigurationAdapter.getList({
      filters: {
        type: "landing-page",
        scope: "multi-view",
        status: "active",
        //@ts-expect-error: This is a valid key:
        isAlreadyFormatted: true,
      },
    });

    const configurations = response?.data ?? [];
    const { personal, company } = partitionUIConfigurationsByVisibility(
      configurations,
      userId
    );

    // Personal overrides company: prefer personal config, then fall back to company
    const landingPageConfig =
      pickDefaultOrFirstUIConfiguration(personal) ??
      pickDefaultOrFirstUIConfiguration(company);

    if (landingPageConfig?.configuration) {
      const config =
        landingPageConfig.configuration as LandingPageConfigurationType;
      const redirectPath = config["redirect-to"];

      if (redirectPath && typeof redirectPath === "string") {
        return redirectPath;
      }
    }

    return null;
  } catch (err) {
    ExceptionUtils.reportException(err, "warning", {
      hint: "Failed to fetch user landing page configuration",
      sourceComponent: "LoginCallback",
    });
    return null;
  }
};
